import { generateCodeVerifier, generateCodeChallenge, generateState } from './pkce'

const GATEKEEPER_URL = (import.meta.env.VITE_GATEKEEPER_URL || 'https://test-gatekeeper.xmslol.cn').replace(/\/+$/, '')
const OAUTH_CLIENT_ID = import.meta.env.VITE_OAUTH_CLIENT_ID || 'ad-platform'
const OAUTH_REDIRECT_URI = import.meta.env.VITE_OAUTH_REDIRECT_URI || `${window.location.origin}/sso/callback`

/**
 * 发起 SSO 授权跳转。
 * 若 gatekeeper 已有登录 session（包括切换了账号的情况），会直接返回新 code，无需用户再次输密码。
 * @param redirectAfter 授权完成后回跳的路径，默认 '/'
 */
export async function redirectToSSO(redirectAfter = '/') {
  const verifier = generateCodeVerifier()
  const challenge = await generateCodeChallenge(verifier)
  const state = generateState()

  localStorage.removeItem('access_token')
  localStorage.removeItem('user_info')
  localStorage.setItem('oauth_code_verifier', verifier)
  localStorage.setItem('oauth_state', state)
  localStorage.setItem('oauth_redirect_after', redirectAfter)

  const authorizeUrl = new URL(`${GATEKEEPER_URL}/api/oauth/authorize`)
  authorizeUrl.searchParams.set('client_id', OAUTH_CLIENT_ID)
  authorizeUrl.searchParams.set('redirect_uri', OAUTH_REDIRECT_URI)
  authorizeUrl.searchParams.set('state', state)
  authorizeUrl.searchParams.set('code_challenge', challenge)
  authorizeUrl.searchParams.set('code_challenge_method', 'S256')

  window.location.replace(authorizeUrl.toString())
}
